/*
 * SiteOwnerTestResults Messages
 *
 * This contains all the text for the SiteOwnerTestResults container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'features.SiteOwnerTestResults';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Test Results',
  },
  total: {
    id: `${scope}.total`,
    defaultMessage: 'total',
  },
  actions: {
    id: `${scope}.actions`,
    defaultMessage: 'Actions',
  },
  name: {
    id: `${scope}.name`,
    defaultMessage: 'Name',
  },
  exercise: {
    id: `${scope}.exercise`,
    defaultMessage: 'Test type',
  },
  lastName: {
    id: `${scope}.lastName`,
    defaultMessage: 'Last Name',
  },
  firstName: {
    id: `${scope}.firstName`,
    defaultMessage: 'First Name',
  },
  email: {
    id: `${scope}.email`,
    defaultMessage: 'Email',
  },
  phone: {
    id: `${scope}.phone`,
    defaultMessage: 'Phone',
  },
  date: {
    id: `${scope}.date`,
    defaultMessage: 'Date',
  },
  time: {
    id: `${scope}.time`,
    defaultMessage: 'Time',
  },
  location: {
    id: `${scope}.location`,
    defaultMessage: 'Location',
  },
  tester: {
    id: `${scope}.tester`,
    defaultMessage: 'Tester',
  },
  status: {
    id: `${scope}.status`,
    defaultMessage: 'Status',
  },
  valid: {
    id: `${scope}.valid`,
    defaultMessage: 'Valid',
  },
  invalid: {
    id: `${scope}.invalid`,
    defaultMessage: 'Invalid',
  },
  markAsValid: {
    id: `${scope}.markAsValid`,
    defaultMessage: 'Mark as Valid',
  },
  markAsInvalid: {
    id: `${scope}.markAsInvalid`,
    defaultMessage: 'Mark as Invalid',
  },
  deleteSelected: {
    id: `${scope}.deleteSelected`,
    defaultMessage: 'Delete Selected',
  },
});

